import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=df4c0d6c&scoped=true&"
import script from "./Box.vue?vue&type=script&lang=js&"
export * from "./Box.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/featured.css?vue&type=style&index=0&id=df4c0d6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4c0d6c",
  null
  
)

export default component.exports